import React, { useState } from "react";
import { Modal, Button, Spinner, Alert } from "react-bootstrap";
import CursoSelector from "./CursoSelector";
import MaestrasSelector from "./MaestrasSelector";
import FechaSelector from "./FechaSelector";
import useAsistenciaLogic from "./useAsistenciaLogic";
import { AiOutlineCalendar } from "react-icons/ai";
import AsistenciaListModal from "./AsistenciaListModal";
import "./Asistencia.css";
import ExcusaModal from "./ExcusaModal";

const AsistenciaModal = () => {
  const {
    isOpen,
    setIsOpen,
    cursos,
    selectedCurso,
    setSelectedCurso,
    fecha,
    selectedMaestras,
    isLoading,
    showSuccessAlert,
    handleCursoClick,
    handleSubmit,
    handleMaestraToggle,
    formatToISO,
    setFecha,
    handleCloseModal,
    setSelectedMaestras,
    editingAsistencia,
    setEditingAsistencia,
  } = useAsistenciaLogic();

  const [showAsistenciaList, setShowAsistenciaList] = useState(false);
  const [showWarningAlert, setShowWarningAlert] = useState(false);
  const [showExcusaModal, setShowExcusaModal] = useState(false);
  const [asistenciaSeleccionada, setAsistenciaSeleccionada] = useState(null);

  const handleCursoAndShowList = (curso) => {
    handleCursoClick(curso);
    setShowAsistenciaList(true);
  };
  const handleCloseModalAll = () => {
    setShowExcusaModal(false);
    setShowAsistenciaList(false);
    handleCloseModal();
  };

  if (cursos.length === 0) return <></>;

  return (
    <div id="asistencia-modal">
      <button
        onClick={() => setIsOpen(true)}
        style={{ background: "none", border: "0" }}
      >
        <AiOutlineCalendar /> Registrar Asistencia
      </button>

      <Modal show={isOpen} onHide={handleCloseModalAll} size="lg">
        <Modal.Header closeButton>
          <Modal.Title>Asistencias</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          {showWarningAlert && (
            <Alert
              variant="warning"
              onClose={() => setShowWarningAlert(false)}
              dismissible
            >
              Es posible que esta fecha ya tenga asistencia registrada. Verifica
              antes de continuar.
            </Alert>
          )}
          {isLoading ? (
            <div className="d-flex justify-content-center p-5">
              <Spinner />
            </div>
          ) : (
            <>
              {showSuccessAlert && (
                <Alert variant="success">
                  Asistencia registrada exitosamente.
                </Alert>
              )}
              {!selectedCurso ? (
                <CursoSelector
                  cursos={cursos}
                  handleCursoClick={handleCursoAndShowList}
                />
              ) : showExcusaModal ? (
                <ExcusaModal
                  asistencia={asistenciaSeleccionada}
                  onClose={() => setShowExcusaModal(false)}
                />
              ) : showAsistenciaList ? (
                <AsistenciaListModal
                  cursoId={selectedCurso.id}
                  onClose={() => setShowAsistenciaList(false)}
                  onEdit={(asistencia) => {
                    setFecha(asistencia.fecha);
                    setSelectedMaestras(asistencia.maestras_asistentes);
                    setEditingAsistencia(asistencia);
                    setShowAsistenciaList(false);
                  }}
                  onExcusa={(asistencia) => {
                    setAsistenciaSeleccionada(asistencia);
                    setShowExcusaModal(true);
                  }}
                />
              ) : (
                <>
                  <h6>{selectedCurso.nombre}</h6>
                  <h6>
                    {selectedCurso.empresa?.[0]?.nombre} -{" "}
                    {selectedCurso.comuna}
                  </h6>
                  <FechaSelector
                    fecha={fecha}
                    setFecha={(f) => {
                      setFecha(f);
                      setShowWarningAlert(true); // Show alert when date is selected
                    }}
                    f_inicio={selectedCurso.f_inicio}
                    f_termino={selectedCurso.f_termino}
                    formatToISO={formatToISO}
                    disabled={!!editingAsistencia} // ✅ disables date input if editing
                  />

                  <MaestrasSelector
                    maestras={selectedCurso.elegidas}
                    selectedMaestras={selectedMaestras}
                    handleToggle={handleMaestraToggle}
                    setSelectedMaestras={setSelectedMaestras}
                  />
                </>
              )}
            </>
          )}
        </Modal.Body>

        <Modal.Footer>
          {selectedCurso && !showAsistenciaList && (
            <Button
              variant="success"
              onClick={handleSubmit}
              disabled={!fecha || selectedMaestras.length === 0}
            >
              Guardar Asistencia
            </Button>
          )}
          <Button
            variant="secondary"
            onClick={() => {
              if (!selectedCurso) {
                handleCloseModal(); // from CursoSelector
              } else if (showExcusaModal) {
                setShowExcusaModal(false); // ← back from ExcusaPanel to list
              } else if (!showAsistenciaList) {
                setEditingAsistencia(null);
                setShowAsistenciaList(true); // back from form to list
              } else {
                setSelectedCurso(null); // back from list to CursoSelector
                setShowAsistenciaList(false);
              }
            }}
          >
            Volver
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default AsistenciaModal;
